import React, { Component } from 'react';
import HeaderLogin from './HeaderLogin';
import HeaderAllPage from './HeaderAllPage';

class AppHeader extends Component {
  constructor() {
    super();
    this.state={ showHeader: false }
  }

  renderAppHeader() {
    const Path = window.location.pathname;
    const url = Path.split('/');
    if ( typeof url[2] === 'undefined' || url[2] === '' || url[2] === 'register' ) {
      return <HeaderLogin />;
    } else if ( url[2] === 'dashboard' || url[2] === 'share' || url[2] === 'deposit' || url[2] === 'loan' || url[2] === 'payment' || url[2] === 'guarantor' || url[2] === 'password' || url[2] === 'message' ) {
      return <HeaderAllPage />;
    } else if ( url[2] === 'read' && url[3] === 'message' ) {
      return <HeaderAllPage />;
    }
  }

  render() {
    return (
      <div>
        {this.renderAppHeader()}
      </div>
    );
  }
}
export default AppHeader;
